import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import "@/App.css";
import Landing from "./pages/Landing";
import Pricing from "./pages/Pricing";
import PaymentSuccess from "./pages/PaymentSuccess";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import Reissue from "./pages/Reissue";
import AdminReissued from "./pages/AdminReissued";
import Verify from "./pages/Verify";
import CertificateRender from "./pages/CertificateRender";
import IssuerLogin from "./pages/IssuerLogin";
import IssuerSignup from "./pages/IssuerSignup";
import IssuerDashboard from "./pages/IssuerDashboard";
import AdminTemplates from "./pages/AdminTemplates";
import TemplateEditor from "./pages/TemplateEditor";
import CreateCertificate from "./pages/CreateCertificate";
import IssueCertificates from "./pages/IssueCertificates";
import ViewCertificates from "./pages/ViewCertificates";
import Settings from "./pages/Settings";
import RecipientAuth from "./pages/RecipientAuth";
import RecipientWallet from "./pages/RecipientWallet";
import AppSumoRedeem from "./pages/AppSumoRedeem";
import CookieConsent from "./components/CookieConsent";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/reissue" element={<Reissue />} />
            <Route path="/verify/:serial" element={<Verify />} />
            <Route path="/render" element={<CertificateRender />} />
            
            <Route path="/appsumo" element={<AppSumoRedeem />} />
            <Route path="/redeem" element={<AppSumoRedeem />} />
            
            <Route path="/issuer/login" element={<IssuerLogin />} />
            <Route path="/issuer/signup" element={<IssuerSignup />} />
            <Route path="/issuer/dashboard" element={<IssuerDashboard />} />
            <Route path="/issuer/admin/templates" element={<AdminTemplates />} />
            <Route path="/issuer/template-editor" element={<TemplateEditor />} />
            <Route path="/issuer/create" element={<CreateCertificate />} />
            <Route path="/issuer/issue/:certId" element={<IssueCertificates />} />
            <Route path="/issuer/certificates" element={<ViewCertificates />} />
            <Route path="/issuer/settings" element={<Settings />} />
            <Route path="/issuer/admin/reissued" element={<AdminReissued />} />
            
            <Route path="/recipient/auth" element={<RecipientAuth />} />
            <Route path="/recipient/wallet" element={<RecipientWallet />} />
          </Routes>
          <CookieConsent />
        </BrowserRouter>
        <Toaster position="top-center" />
      </div>
    </HelmetProvider>
  );
}

export default App;
